import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, NgZone, inject } from '@angular/core';

import { startNoBrowserAutofill } from './no-browser-autofill';
import { AppShellComponent } from './shared/components/app-shell.component';

@Component({
  selector: 'lm-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
  imports: [AppShellComponent],
})
export class AppComponent {
  constructor() {
    const zone = inject(NgZone);
    const host = inject<ElementRef<HTMLElement>>(ElementRef);

    // Outside Angular's zone: the observer fires on every DOM change and must never start change detection. It watches this
    // component's own host (everything the site draws is inside it) and stops when the root is destroyed (review MR !1 #8).
    const stop = zone.runOutsideAngular(() => startNoBrowserAutofill(host.nativeElement));
    inject(DestroyRef).onDestroy(stop);
  }
}
